import { useMemo } from "react";
import { Trophy } from "@phosphor-icons/react";
import { formatDateIT } from "@/lib/formatDate";
import { MilestoneThumb } from "@/components/shared/MilestoneThumb";
import { OverviewCard, OverviewEmpty } from "./Card";

/**
 * Extra widget (e) — Badge sbloccati recentemente.
 * I dati arrivano da GET /clients/{id}/badges → { definitions: [...] }.
 */
export function RecentBadgesWidget({ badges }) {
  const recent = useMemo(() => {
    const defs = badges?.definitions || [];
    return defs
      .filter((b) => b.unlocked && b.unlocked_at)
      .sort((a, b) => (a.unlocked_at < b.unlocked_at ? 1 : -1))
      .slice(0, 4);
  }, [badges]);

  const totalUnlocked = (badges?.definitions || []).filter((b) => b.unlocked).length;
  const totalDefs = (badges?.definitions || []).length;

  return (
    <OverviewCard
      title="Badge recenti"
      icon={Trophy}
      iconColor="text-[#FFCC00]"
      testId="overview-recent-badges"
      accent={totalDefs ? `${totalUnlocked}/${totalDefs}` : null}
    >
      {recent.length === 0 ? (
        <OverviewEmpty message="Nessun badge sbloccato per il momento." />
      ) : (
        <ul className="space-y-2">
          {recent.map((b) => (
            <li
              key={b.code}
              className="flex items-center gap-3 p-2 rounded-lg bg-[#171717] border border-[#1F1F1F]"
              data-testid={`overview-badge-${b.code}`}
            >
              {b.thumbnail_path ? (
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-transparent">
                  <MilestoneThumb
                    path={b.thumbnail_path}
                    alt={b.name}
                    className="max-w-full max-h-full w-full h-full object-contain object-center"
                  />
                </div>
              ) : (
                <span className="text-2xl leading-none flex-shrink-0">{b.icon || "🏅"}</span>
              )}
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-white truncate">{b.name}</p>
                <p className="text-[11px] text-zinc-500 truncate">
                  {b.unlocked_at ? formatDateIT(b.unlocked_at) : ""}
                  {b.description ? ` · ${b.description}` : ""}
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </OverviewCard>
  );
}
